module.exports = __webpack_public_path__ + "3be42ce4e828d9269710e659703393de.png";